import { Box, styled } from '@mui/material';
import { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

const StyledBox = styled(Box)(({ theme }) => ({
    position: 'absolute',
    bottom: 4,
    color: theme.palette.error.main,
}));

/**
 * Debug component that can display the Elasticsearch score in the UI.
 */
export const SearchScoreOverlay = ({ score }: { score: number }): ReactElement | null => {
    const [searchParams] = useSearchParams();

    if (!searchParams.has('debugScore')) {
        return null;
    }

    return <StyledBox>Score: {score}</StyledBox>;
};
